import { useParams } from "react-router-dom";

import Countdown, { CountdownApi } from "react-countdown";

function KYDCountdown({
  ms,
  didComplete,
}: {
  ms: number;
  didComplete: () => void;
}) {
  const { event_id } = useParams();
  const renderCountdown = ({
    minutes,
    seconds,
    completed,
    api,
  }: {
    minutes: number;
    seconds: number;
    completed: boolean;
    api: CountdownApi;
  }) => {
    if (completed) {
      didComplete();
    } else {
      return (
        <span>
          {`${minutes.toString().padStart(2, "0")}:${seconds
            .toString()
            .padStart(2, "0")}`}
        </span>
      );
    }
  };

  return <Countdown date={ms} renderer={renderCountdown} />;
}

export default KYDCountdown;
